import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ApiTokenService } from '@services/api-token.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FunctService, DtoService }  from "@services/index";
import { NgModel } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Component({
  selector: 'share-app-otpsetting',
  templateUrl: './otpsetting.component.html',
  styleUrls: ['./otpsetting.component.scss']
})
export class OTPSettingComponent implements OnInit {

  otpChannelList: any[] = [];
  selectedChannel: any={};
  @ViewChild('emailRef')
  emailRef!: NgModel;
  email: any= null;
  phoneNo: any= '';
  @Output() backemit = new EventEmitter();
  constructor( 
    
    private dto: DtoService,
    private http: HttpClient,
    private storage: LocalStorageService,
    private apiTokenServer: ApiTokenService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService, 
    private funct: FunctService,
    private translateService: TranslateService,  ) { }

  ngOnInit(): void {
    const prefix = this.storage.retrieve('localPhonePrefix');
    const phone = this.storage.retrieve('localPhoneValue');
    
    if (phone.startsWith('0')) {
      this.phoneNo = prefix + phone.substring(1, phone.length);
    }
    if (phone.startsWith('+95')) {
      this.phoneNo = phone;
    }
    else {
      this.phoneNo = prefix + phone;
    }
    this.getOtpChannelList();

  }
  handleError(error: HttpErrorResponse){
    if(error.status == 0){
      this.toastr.error("", 'check your internet connection', {
        timeOut: 3000,
        positionClass: 'toast-top-center',
        });
    }
    
    if(error.status == 423)
    {
      this.toastr.error("", this.translateService.instant("youNeedLogin"), {
        timeOut: 3000,
        positionClass: 'toast-top-center',
        });
        this.storage.clear('token');
        this.storage.clear('isUserLoggedIn');
    }
    
    if(error.status == 400)
    {
       this.toastr.error("Bad request.", 'Invalid!', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
        });
    }
    return throwError(error);
  }
  getOtpChannelList() {  
    this.spinner.show("refreshLoading");
    this.apiTokenServer.getNotToken(`otpChannel/getOTPChannelByPhone?phone_no=${encodeURIComponent(this.phoneNo)}`)
    .then(async (response: any)=> {         
      if(response.status == 200){       
        if(this.funct.fileName === "crazy"){
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].icon_url =  response.data[i].icon_url.replace('lucky2d', 'crazybossy');
          }
        }  
        console.log('OTP Channel List:', response);
        this.otpChannelList = response.data;
        for (let j = 0; j < response.data.length; j++) {
          if (response.data[j].is_default) {
            this.selectedChannel = response.data[j];
            break;
          }
        }
        this.spinner.hide("refreshLoading");
      }else{
         this.toastr.error("", response.data.message, {
          timeOut: 3000,
          positionClass: 'toast-top-center',
          });
          this.spinner.hide("refreshLoading");
          return;    
      }             
        
   })          
   .catch(async error=> {            
      this.toastr.error("", error.response?.data.message, {
          timeOut: 3000,
          positionClass: 'toast-top-center',
          });
          this.spinner.hide("refreshLoading");
        return;   
   });  
  }
  trackByOtpChannelList(index: number, item: any): number {
    return item.channel_id; 
  }

  onSelectOtpChannel(channel: any){
    this.selectedChannel = channel;   
  }
  checkEmail() { 
    if(this.email === null || this.email === undefined || this.email.trim() === ''){
      var required = this.translateService.instant("requiredFiled");
      required=required.toString().replace("{{value}}",  this.translateService.instant('email_address'));
      this.toastr.warning("", required, {
        timeOut: 3000,
        positionClass: 'toast-top-center',
      });
      
      return;
    }   
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var check = pattern.test(this.email);
    
    if(check){
      this.emailRef.control.setErrors(null);
    }else{
      this.emailRef.control.setErrors({ 'invalidEmail': true });
    }  
  }

  onSaveOtpSetting() {      
     if(this.selectedChannel.channel_code === 'EMAIL' && this.selectedChannel.destination === null && this.email == null){
      this.checkEmail();
      return;
     }
     if(this.email !== null && this.email !== undefined && this.email.trim() !== '') {
      this.selectedChannel.destination = this.email;
     }      
     var model= {
        phone_no: this.phoneNo,
        is_default: true,
        channel_code: this.selectedChannel.channel_code,
        destination: this.selectedChannel.destination
      } 
     
      this.apiTokenServer.postNotToken(`userOtpSetting/insert`, model)
          .then(async (response: any)=>{
            console.log('Save OTP Setting Response:', response);
            if(response.status == 200){       
              this.toastr.success("", response.message, {
              timeOut: 3000,
              positionClass: 'toast-top-center',
              });
              this.getOtpChannelList();              
            }else{
              this.toastr.error("", response.message, {
              timeOut: 3000,
              positionClass: 'toast-top-center',
              });
              return; 
            }
          }).catch((err: any)=>{
              this.toastr.error("", err.response.message, {
              timeOut: 3000,
              positionClass: 'toast-top-center',
              });
              return; 
      });
  }
   goBack(){
   this.backemit.emit(false)
  }
 refreshPage(){
    this.ngOnInit();
  }

  
}
